import { SVGProps } from 'react';

const SquareDivide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default SquareDivide;
